module.exports = __webpack_public_path__ + "img/logo-menu.27824b91.png";